<template
  src="./index.html"
  lang="html"></template>
<style
  src="../../stylus/main.css"
  lang="css">
</style>


<script>
  export default {
    props: {
      placement: {
        type: String,
        default: 'top',
        validator: value => [
          'top',
          'left',
          'left',
          'bottom'
        ].includes(value.toLowerCase())
      },
      isVisible: {
        type: Boolean,
        default: false
      },
      content: {
        type: String,
        required: true,
        default: ''
      }
    },
    computed: {
      classObject () {
        return [
          this.placement,
          this.type,
          {
            isVisible: this.isVisible
          }
        ];
      }
    }
  };
</script>
